import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { ActivityLogEntry, ActivityLogEntryFilters } from '../../models/activity-log';
import { ListResponse } from '../../models/list-response';

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {
  /**
   * A service providing access to the activity log via the API.
   */
  constructor(
    private apiService: ApiService
  ) {}

  getActivityLogEntries(pageNumber?: number,
                        pageSize?: number,
                        filters?: ActivityLogEntryFilters): Promise<ListResponse<ActivityLogEntry>> {
    return this.apiService.getCollection<ActivityLogEntry, ActivityLogEntryFilters>(
      'activity-log/',
      pageNumber,
      pageSize,
      filters,
      false
    );
  }

  editActivityLogEntryNotes(entryId: number, notes: string): Promise<void> {
    return this.apiService
      .postToAPI<any>(
        'gym-endpoints/edit-activity-log-entry-notes/' + entryId.toString() + '/',
        {notes}
      )
      .then();
  }
}
